import {useEffect, useRef, useState} from 'react';
import {useParams} from 'react-router-dom';
import {IGameVersion} from '../model/gameVersion/GameVersion';
import {useRootStore} from './useRootStore';
import {IGameVersionSearchParams} from '../api/requests/GameVersionApiGateway';
import {usePublishSnackbarNotification} from '@yakoffice/snackbar';

interface useGameVersionsResult {
    isLoaded: boolean;
    gameVersions: IGameVersion[] | null;
}

export const useGameVersions = (searchParams?: IGameVersionSearchParams, callbackTrigger?: number) => {

    const rootStore = useRootStore();
    const publishNotification = usePublishSnackbarNotification();
    const {projectId} = useParams<{ projectId: string }>();
    const effectRan = useRef(false);

    const [result, setResult] = useState<useGameVersionsResult>({isLoaded: false, gameVersions: []});

    const abortController = new AbortController();

    useEffect(() => {
        setResult({isLoaded: false, gameVersions: []});

        rootStore.gameVersionStore
            .loadGameVersions({...searchParams})
            .then(() => {
                setResult({isLoaded: true, gameVersions: rootStore.gameVersionStore.gameVersions});
                const signal = abortController.signal;
            })
            .catch((e) =>
                publishNotification({
                    text: `Error loading game versions: ${e.message}`,
                    canClose: true,
                })
            );

        return () => {
            abortController.abort();
            effectRan.current = true;
        };
    }, [rootStore.gameVersionStore.gameVersions, projectId, searchParams, callbackTrigger]);

    return result;
};
